// React for Website

import React from "react";
//outsource
import { Row, Col, Input } from "antd";

//components
const { Search } = Input;

const SearchVoucher = ({ search, setSearch }) => {
  // -------------------------- VAR --------------------------
  // -------------------------- STATE --------------------------

  // -------------------------- REDUX --------------------------
  // -------------------------- FUNCTION --------------------------
  const hanleChange = (e) => {
    const values = e.target.value;
    setSearch(values);
  };
  // -------------------------- EFFECT --------------------------

  // -------------------------- RENDER --------------------------

  // -------------------------- MAIN --------------------------
  return (
    <Search
      style={{ width: "100%" }}
      placeholder="Search by Voucher Code (6 digit)"
      value={search}
      onChange={hanleChange}
    />
  );
};

export default SearchVoucher;
